import React from "react";

export default function FeaturesLiquid() {
  const features = [
    {
      icon: "💻",
      title: "Professional Design",
      description:
        "Custom-designed landing pages that reflect your brand identity and captivate your audience.",
    },
    {
      icon: "⚡",
      title: "Fast Performance",
      description:
        "Optimized for speed and performance to ensure the best user experience across all devices.",
    },
    {
      icon: "🔒",
      title: "Secure & Reliable",
      description:
        "Built with security in mind, featuring SSL certificates and reliable hosting infrastructure.",
    },
    {
      icon: "📱",
      title: "Mobile Responsive",
      description:
        "Fully responsive designs that look perfect on all screen sizes and devices.",
    },
    {
      icon: "🎯",
      title: "SEO Optimized",
      description:
        "Search engine optimized to help your business get discovered by potential customers.",
    },
    {
      icon: "📊",
      title: "Analytics Ready",
      description:
        "Integrated with analytics tools to track your website performance and visitor behavior.",
    },
  ];

  return (
    <section className="section-liquid features-section">
      <div className="container-liquid">
        <div style={{ textAlign: "center", marginBottom: "60px" }}>
          <span className="subheading-liquid">Features</span>
          <h2
            className="heading-liquid"
            style={{
              fontSize: "clamp(2rem, 4vw, 3rem)",
              marginTop: "16px",
              marginBottom: "24px",
            }}
          >
            We have Amazing{" "}
            <span
              style={{
                background: "var(--gradient-primary)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                color: "#007AFF", // Fallback color
              }}
            >
              Service.
            </span>
          </h2>
          <p
            className="text-liquid"
            style={{
              fontSize: "1.2rem",
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            Unlock the Power of Our Service. Stand out online with our
            expertise.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: "30px",
          }}
        >
          {features.map((feature, index) => (
            <div
              key={index}
              className="glass-secondary liquid-float"
              style={{
                padding: "30px",
                textAlign: "center",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                animationDelay: `${index * 0.1}s`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-10px)";
                e.currentTarget.style.boxShadow = "var(--shadow-hover)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 24px 0 rgba(31, 38, 135, 0.25)";
              }}
            >
              <div
                style={{
                  fontSize: "3rem",
                  marginBottom: "20px",
                  filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))",
                }}
              >
                {feature.icon}
              </div>
              <h3
                className="heading-liquid"
                style={{
                  fontSize: "1.25rem",
                  marginBottom: "16px",
                }}
              >
                {feature.title}
              </h3>
              <p
                className="text-liquid"
                style={{
                  lineHeight: "1.6",
                }}
              >
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
